import React from "react";
import { AMOUNT_B } from "../../../../../lib/constants";
import { r1099AmountDisplayTexts } from "../../../../../lib/languagePacks/en-us";
import AmountHeading from "../../AmountContainer/AmountHeading/AmountHeading";
import Amount from "../../AmountContainer/AmountInput/Amount";

export default function Box10({ amountObj, changeHandler }: any) {
  return (
    <>
      <AmountHeading heading={r1099AmountDisplayTexts.irrAmount} amountNum="10" />
      <Amount
        type="text"
        id={AMOUNT_B}
        placeHolder="0.00"
        class_="payer-details-input" // Only one class can be passed
        value={amountObj.amountB}
        onChangeHandler={changeHandler}
      />
    </>
  );
}
